import {useSnackBar} from "./useSnackBar";

export const Snack = () => {
    useSnackBar()
    return <></>
}